import { render } from "./LiteratureSearch.vue?vue&type=template&id=00758e95"
import script from "./LiteratureSearch.vue?vue&type=script&lang=js"
export * from "./LiteratureSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__